// src/components/medical/LeadershipTeam.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import claudiaVonTeinPortrait from "../assets/Images/Team/claudia-von-tein.jpg";
import carstenDictusPortrait from "../assets/Images/Team/carsten-dictus.jpg";
import thomasVonMoltkePortrait from "../assets/Images/Team/thomas-von-moltke.jpg";
import michaelHartmannPortrait from "../assets/Images/Team/michael-hartmann.jpg";
import evaRissUngamPortrait from "../assets/Images/Team/eva-riss-ungam.jpg";
import ralfHauserPortrait from "../assets/Images/Team/ralf-hauser.jpg";

const TEAM = [
  {
    name: "Claudia von Tein",
    role: "Geschäftsleitung ",
    location: "",
    image: claudiaVonTeinPortrait,
    to: "/medical/team/claudia-von-tein",
    email: "mailto:claudia@repexo-medical.de",
  },
  {
    name: "Carsten Dictus",
    role: "Abteilungsleiter Research",
    location: "Frankfurt am Main",
    image: carstenDictusPortrait,
    to: "/medical/team/carsten-dictus",
    email: "mailto:carsten@repexo-medical.de",
  },
  {
    name: "Dr. med. Thomas von Moltke",
    role: "Abteilungsleiter Healthcare",
    location: "Frankfurt am Main",
    image: thomasVonMoltkePortrait,
    to: "/medical/team/thomas-von-moltke",
    email: "mailto:thomas@repexo-medical.de",
  },
  {
    name: "Michael Hartmann",
    role: "Leitender Personalberater Vertrieb",
    location: "Frankfurt am Main",
    image: michaelHartmannPortrait,
    to: "/medical/team/michael-hartmann",
    email: "mailto:michael@repexo-medical.de",
  },
  {
    name: "Dr. med. Eva Riss Ungam",
    role: "Abteilungsleitung internationale Projekte",
    location: "Frankfurt am Main",
    image: evaRissUngamPortrait,
    to: "/medical/team/eva-riss-ungam",
    email: "mailto:eva@repexo-medical.de",
  },
  {
    name: "Ralf Hauser",
    role: "Leitender Personalberater medical ",
    location: "Frankfurt am Main",
    image: ralfHauserPortrait,
    to: "/medical/team/ralf-hauser",
    email: "mailto:ralf@repexo-medical.de",
  },
];

export default function LeadershipTeam({
  variant = "home",
  teamPagePath = "/medical/team",
  sectionTitle = "Lernen Sie unser Führungsteam  kennen",
}) {
  const isHome = variant === "home";
  const visibleTeam = isHome ? TEAM.slice(0, 3) : TEAM;

  return (
    <section className="w-full">
      <div className="container-app py-12">
        {/* Header */}
        <div className="flex items-center justify-between gap-4">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
            {sectionTitle}
          </h2>

          {/* Desktop / tablet: show \"Mehr Experten\" next to heading */}
          {isHome && (
            <div className="hidden lg:block">
              <Link
                to={teamPagePath}
                className="group btn btn-outline text-xs uppercase tracking-[0.12em]"
              >
                Mehr Experten anzeigen
                <ArrowRight
                  className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5"
                  aria-hidden
                />
              </Link>
            </div>
          )}
        </div>

        {/* Cards: horizontal slider on mobile, grid from lg */}
        <div
          className="mt-8 flex overflow-x-auto overflow-y-hidden snap-x snap-mandatory gap-4 pb-2 -mx-4 px-4 lg:mx-0 lg:px-0 lg:grid lg:overflow-visible lg:snap-none lg:gap-6 lg:grid-cols-3"
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          {visibleTeam.map((p) => (
            <PersonCard key={p.name} person={p} />
          ))}
        </div>

        {/* Button below cards - mobile / tablet only (keeps CTA visible near slider) */}
        {isHome && (
          <div className="mt-8 flex justify-end lg:hidden">
            <Link
              to={teamPagePath}
              className="group btn btn-outline text-xs uppercase tracking-[0.12em]"
            >
              Mehr Experten anzeigen
              <ArrowRight
                className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5"
                aria-hidden
              />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}

function PersonCard({ person }) {
  const imageSrc = person.image2x ?? person.image;
  const imageSrcSet = person.image2x
    ? `${person.image} 1x, ${person.image2x} 2x`
    : `${person.image} 1x`;

  return (
    <article
      className="
        relative rounded-[26px] border border-[#E6DED3] bg-white overflow-hidden
        shadow-[0_10px_30px_rgba(0,0,0,0.04)]
        flex-none w-[85%] min-w-[85%] snap-center
        lg:flex-initial lg:w-auto lg:min-w-0
      "
    >
      {/* Avatar: full-height left panel */}
      <div className="absolute inset-y-0 left-0 w-[115px] overflow-hidden sm:w-[125px]">
        <img
          src={imageSrc}
          srcSet={imageSrcSet}
          sizes="(min-width: 640px) 125px, 115px"
          alt={person.name}
          className="block h-full w-full object-cover object-center"
          loading="eager"
          decoding="async"
          style={{ imageRendering: "-webkit-optimize-contrast" }}
        />
      </div>

      {/* Text */}
      <div className="min-h-[170px] pl-[115px] sm:pl-[125px]">
        <div className="min-w-0 px-6 py-6 sm:px-7">
          <h3
           
            className="text-xl font-medium text-gray-900 underline underline-offset-4 decoration-transparent hover:decoration-gray-900 transition-[text-decoration-color] duration-300"
          >
            {person.name}
          </h3>

          <p className="mt-3 text-[14px] leading-relaxed text-gray-900/85">
            {person.role}
          </p>

          <p className="mt-2 text-[12px] font-semibold text-gray-900/70">{person.location}</p>

          {/* Mail icon row */}
         
        </div>
      </div>
    </article>
  );
}

